import { isMemberImportMappingResponse, } from '@urbanik/api-contracts';
export class MemberImportMappingApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'MemberImportMappingApiError';
    }
}
export async function getMemberImportMapping(baseUrl, signal) {
    let response;
    try {
        response = await fetch(`${baseUrl.replace(/\/$/, '')}/identity/member-import/mapping`, {
            headers: { Accept: 'application/json' },
            credentials: 'include',
            signal: signal ?? null,
        });
    }
    catch {
        throw new MemberImportMappingApiError('unavailable', 'No pudimos mapear la fuente histórica.');
    }
    if (response.status === 401)
        throw new MemberImportMappingApiError('unauthorized', 'Debes iniciar sesión.');
    if (response.status === 403)
        throw new MemberImportMappingApiError('forbidden', 'No tienes permiso para mapear la fuente.');
    let payload;
    try {
        payload = await response.json();
    }
    catch {
        throw new MemberImportMappingApiError('invalid', 'El servidor devolvió una respuesta inválida.');
    }
    if (!response.ok)
        throw new MemberImportMappingApiError('unavailable', typeof payload.message === 'string'
            ? payload.message
            : 'No pudimos completar el mapeo.');
    if (!isMemberImportMappingResponse(payload))
        throw new MemberImportMappingApiError('invalid', 'El contrato del mapeo no es válido.');
    return payload;
}
